"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * [[AudioVideoControllerState]] includes the compute resources shared by [[Task]].
 */

var AudioVideoControllerState = /*#__PURE__*/_createClass(function AudioVideoControllerState() {
  _classCallCheck(this, AudioVideoControllerState);

  this.logger = null;
  this.browserBehavior = null;
  this.signalingClient = null;
  this.meetingSessionConfiguration = null;
  this.peer = null;
  this.previousSdpOffer = null;
  this.sdpOfferInit = null;
  this.audioVideoController = null;
  this.realtimeController = null;
  this.videoTileController = null;
  this.mediaStreamBroker = null;
  this.audioMixController = null;
  this.activeAudioInput = null;
  this.activeVideoInput = null;
  this.transceiverController = null;
  this.indexFrame = null;
  this.iceCandidates = [];
  this.iceCandidateHandler = null;
  this.iceGatheringStateEventHandler = null;
  this.sdpAnswer = null;
  this.turnCredentials = null;
  this.reconnectController = null;
  this.removableObservers = [];
  this.audioProfile = null;
  this.videoStreamIndex = null;
  this.videoDownlinkBandwidthPolicy = null;
  this.videoUplinkBandwidthPolicy = null;
  this.lastKnownVideoAvailability = null;
  this.localVideoSender = null;
  this.localAudioSender = null;
  this.videoCaptureAndEncodeParameter = null; // An unordered list of IDs provided by the downlink policy that
  // we will eventually subscribe to.

  this.videosToReceive = null; // The last processed set of IDs provided by the policy, so that we can
  // compare what changes were additions, stream switches, or removals.

  this.lastVideosToReceive = null; // An ordered list corresponding to `videosToReceive` where the order
  // itself correspond to transceivers; 0 in this list corresponds to an inactive tranceiver.

  this.videoSubscriptions = null;
  this.videosPaused = null;
  this.videoDuplexMode = null;
  this.volumeIndicatorAdapter = null;
  this.statsCollector = null;
  this.connectionMonitor = null;
  this.videoInputAttachedTimestampMs = 0;
  this.audioDeviceInformation = {};
  this.videoDeviceInformation = {};
  this.enableSimulcast = false;
  this.eventController = null;
  this.signalingOpenDurationMs = null;
  this.iceGatheringDurationMs = null;
  this.startAudioVideoTimestamp = null;
  this.attendeePresenceDurationMs = null;
  this.meetingStartDurationMs = null;
  this.poorConnectionCount = 0;
  this.maxVideoTileCount = 0;
  this.startTimeMs = null;
});

exports.default = AudioVideoControllerState;